<template>
  <section id="dashboard-ecommerce">
    <b-overlay :show="onProgress">
      <b-row class="match-height">
        <b-col
            cols="12"
        >
          <statistics :data="data.statisticsItems" />
        </b-col>
      </b-row>
      <b-row class="match-height">
        <b-col md="6" v-if="!onProgress && typeof data.tickets != 'undefined' && data.tickets.length">
          <tickets :table-data="data.tickets" />
        </b-col>


        <b-col
            md="6"
            v-if="!onProgress && typeof data.tasks != 'undefined' &&  data.tasks.length"
        >
          <tasks :data="data.tasks" />
        </b-col>

        <b-col md="6" v-if="!onProgress && typeof data.requests != 'undefined' && data.requests.length">
          <requests :table-data="data.requests" />
        </b-col>

      </b-row>
    </b-overlay>

  </section>
</template>

<script>
import { BRow, BCol,BOverlay } from 'bootstrap-vue'

import Statistics from './DashboardStatistics.vue'
import Tickets from './DashboardTickets.vue'
import Tasks from './DashboardTasks.vue'
import Requests from './DashboardRequests.vue'
import { doubleRaf } from '@/libs/utils'

export default {
  components: {
    BRow,
    BCol,
    Statistics,
    Tickets,
    Tasks,
    Requests,
    BOverlay
  },
  data() {
    return {
      data: {},
      onProgress :false
    }
  },
  mounted() {
    // data
    this.onProgress = true

    this.$http.get('/dashboard/data')
      .then((response) => {
        this.data = response.data

        doubleRaf(()=>{
          this.onProgress = false
        })
      })
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
